import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerAppServiceWorker } from "../shared/app-update";

registerAppServiceWorker("#2563eb");

createRoot(document.getElementById("root")!).render(<App />);
